import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderFillRequestImplEncoder } from "../../encoder/OrderFillRequestImplEncoder";

import * as CubiqTS from "../../index";
import { OrderFillRequest } from "../OrderFillRequest";

export class OrderFillRequestImpl extends ConcreteEncodable implements OrderFillRequest {
  public static enType: string = "com.bcdfx.model.event.OrderFillRequestImpl";

  /*FID=1*/
  public fillRequestType: CubiqTS.FillRequestType;
  /*FID=2*/
  public orderIds: Array<string> | null = null;
  /*FID=3*/
  public stpRequirement: CubiqTS.FillStpRequirement;
  /*FID=4*/
  public positionBook: CubiqTS.PositionBook | null = null;
  /*FID=5*/
  public fillRequestData: Array<CubiqTS.OrderFillData> | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderFillRequestImplEncoder.Instance;
    this.setEncodableType(OrderFillRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "OrderFillRequestImpl[" +
      "fillRequestType=" +
      this.fillRequestType +
      "orderIds=" +
      this.orderIds +
      "stpRequirement=" +
      this.stpRequirement +
      "positionBook=" +
      this.positionBook +
      "fillRequestData=" +
      this.fillRequestData +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
